import React from 'react';
import { Indus, Fact, IndusCheer, FactVerified, IndusAndFact } from '@/components/mascots/Mascots';

// Preview-only page for reviewing mascot artwork.
// Route this at /_mascots to visually check the SVGs at different sizes.
// This page is NOT linked from any menu; it's a design-review tool.
const MascotPreview = () => (
  <div className='max-w-5xl mx-auto p-8 space-y-10'>
    <div>
      <h1 className='text-2xl font-bold'>IndusFact Mascots — Preview</h1>
      <p className='text-sm text-muted-foreground mt-1'>Design review. Not linked from nav.</p>
    </div>

    <section className='grid grid-cols-2 md:grid-cols-4 gap-6'>
      <MascotCard title='Indus (default)'><Indus size={140} /></MascotCard>
      <MascotCard title='Indus (cheer)'><IndusCheer size={140} /></MascotCard>
      <MascotCard title='Fact (default)'><Fact size={140} /></MascotCard>
      <MascotCard title='Fact (verified)'><FactVerified size={140} /></MascotCard>
    </section>

    <section className='space-y-3'>
      <h2 className='text-lg font-semibold'>Side by side — the pair spells IF</h2>
      <MascotCard title='<IndusAndFact />'>
        <IndusAndFact size={140} />
      </MascotCard>
    </section>

    <section className='space-y-3'>
      <h2 className='text-lg font-semibold'>Small sizes (tooltip / toast use)</h2>
      <div className='flex items-end gap-6 p-4 border rounded-lg'>
        <div className='flex items-center gap-2'><Indus size={20} /> <span className='text-sm'>Indus 20px</span></div>
        <div className='flex items-center gap-2'><Fact size={20} /> <span className='text-sm'>Fact 20px</span></div>
        <div className='flex items-center gap-2'><FactVerified size={24} /> <span className='text-sm'>Fact verified 24px</span></div>
      </div>
    </section>
  </div>
);

const MascotCard = ({ title, children }) => (
  <div className='rounded-xl border bg-white p-6 flex flex-col items-center gap-3 shadow-sm'>
    <div>{children}</div>
    <div className='text-sm text-muted-foreground'>{title}</div>
  </div>
);

export default MascotPreview;
